export default function omitKeysFromSourceObject(source) {
  var omittedKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Object.keys(source).reduce(function relocateAcceptedKeys(hash, key) {
    if (omittedKeys.indexOf(key) === -1) {
      hash[key] = source[key];
    }

    return hash;
  }, {});
}